(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    /* =========================================================
     MODAL LAYER
     ========================================================= */

  if (!customElements.get('pupdaily-cart-layer-v3')) {

    class PupDailyCartLayerV3 extends HTMLElement {

      connectedCallback() {

        this.dialog = this.closest('dialog');

        if (!this.dialog) return;

        this.failed = false;

        this.observer = new MutationObserver(() => {
          this.ensureModal();
        });

        this.observer.observe(
          this.dialog,
          {
            attributes: true,
            attributeFilter: ['open']
          }
        );

        this.ensureModal();

      }

      ensureModal() {

        const dialog = this.dialog;

        if (
          !this.isConnected ||
          !dialog
        ) {
          return;
        }

        if (!dialog.open) {
          this.failed = false;
          return;
        }

        if (
          this.failed ||
          typeof dialog.showModal !== 'function'
        ) {
          return;
        }

        try {

          if (dialog.matches(':modal')) {
            return;
          }

        } catch (_) {

          return;

        }

        const focusedElement = document.activeElement;

        dialog.removeAttribute('open');

        try {

          dialog.showModal();

          if (
            focusedElement instanceof HTMLElement &&
            dialog.contains(focusedElement)
          ) {

            focusedElement.focus({
              preventScroll: true
            });

          }

        } catch (_) {

          this.failed = true;

          dialog.setAttribute(
            'open',
            ''
          );

        }

      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

    }

    customElements.define(
      'pupdaily-cart-layer-v3',
      PupDailyCartLayerV3
    );

  }


  /* =========================================================
     TIMER — 10 MINUTES
     ========================================================= */

  if (!customElements.get('pupdaily-cart-timer-v3')) {

    class PupDailyCartTimerV3 extends HTMLElement {

      static storageKey = 'pupdaily-cart-reminder-v1';

      static deadline = null;

      static get observedAttributes() {
        return ['hidden'];
      }

      attributeChangedCallback(
        name,
        oldValue,
        newValue
      ) {

        if (
          name === 'hidden' &&
          newValue !== null &&
          oldValue !== newValue &&
          this.dialog
        ) {

          cancelAnimationFrame(
            this.refreshFrame
          );

          this.refreshFrame =
            requestAnimationFrame(() => {
              this.sync();
            });

        }

      }

      connectedCallback() {

        this.frame =
          requestAnimationFrame(() => {
            this.initialize();
          });

      }

      initialize() {

        if (!this.isConnected) {
          return;
        }

        if (
          this.dataset.empty === 'true'
        ) {

          PupDailyCartTimerV3.deadline = null;

          try {

            sessionStorage.removeItem(
              PupDailyCartTimerV3.storageKey
            );

          } catch (_) {}

          this.hidden = true;

          return;

        }

        this.dialog = this.closest('dialog');

        if (!this.dialog) {
          return;
        }

        this.onVisibility = () => this.sync();

        this.observer =
          new MutationObserver(() => {
            this.sync();
          });

        this.observer.observe(
          this.dialog,
          {
            attributes: true,
            attributeFilter: ['open']
          }
        );

        document.addEventListener(
          'visibilitychange',
          this.onVisibility
        );

        this.sync();

      }

      sync() {

        clearInterval(
          this.interval
        );

        if (
          !this.isConnected ||
          !this.dialog?.open ||
          document.hidden
        ) {
          return;
        }

        const duration =
          10 * 60 * 1000;

        const now =
          Date.now();

        if (
          PupDailyCartTimerV3.deadline === null
        ) {

          let saved = null;

          try {

            saved = Number(
              sessionStorage.getItem(
                PupDailyCartTimerV3.storageKey
              )
            );

          } catch (_) {}

          const validSavedDeadline =
            Number.isFinite(saved) &&
            saved > 0 &&
            saved <= now + duration;

          PupDailyCartTimerV3.deadline =
            validSavedDeadline
              ? saved
              : now + duration;

          try {

            sessionStorage.setItem(
              PupDailyCartTimerV3.storageKey,
              String(
                PupDailyCartTimerV3.deadline
              )
            );

          } catch (_) {}

        }

        this.hidden = false;

        this.tick();

        if (
          Date.now() <
          PupDailyCartTimerV3.deadline
        ) {

          this.interval =
            setInterval(() => {
              this.tick();
            }, 250);

        }

      }

      tick() {

        const output =
          this.querySelector(
            '[data-pd-time]'
          );

        const label =
          this.querySelector(
            '[data-pd-timer-label]'
          );

        if (!output) {
          return;
        }

        const seconds =
          Math.max(
            0,
            Math.ceil(
              (
                PupDailyCartTimerV3.deadline -
                Date.now()
              ) / 1000
            )
          );

        const minutesText =
          String(
            Math.floor(
              seconds / 60
            )
          ).padStart(
            2,
            '0'
          );

        const secondsText =
          String(
            seconds % 60
          ).padStart(
            2,
            '0'
          );

        const time =
          minutesText +
          ':' +
          secondsText;

        if (
          output.textContent !== time
        ) {
          output.textContent = time;
        }

        const labelText =
          seconds === 0
            ? 'You can still check out'
            : 'Order reserved for the next';

        if (
          label &&
          label.textContent !== labelText
        ) {
          label.textContent = labelText;
        }

        if (seconds === 0) {

          clearInterval(
            this.interval
          );

        }

      }

      disconnectedCallback() {

        cancelAnimationFrame(
          this.frame
        );

        cancelAnimationFrame(
          this.refreshFrame
        );

        clearInterval(
          this.interval
        );

        this.observer?.disconnect();

        if (this.onVisibility) {

          document.removeEventListener(
            'visibilitychange',
            this.onVisibility
          );

        }

      }

    }

    customElements.define(
      'pupdaily-cart-timer-v3',
      PupDailyCartTimerV3
    );

  }


  /* =========================================================
     CHECKOUT LABEL + LOCK
     ========================================================= */

  if (!customElements.get('pupdaily-cart-summary-v3')) {

    class PupDailyCartSummaryV3 extends HTMLElement {

      connectedCallback() {

        this.observer =
          new MutationObserver(() => {
            this.schedule();
          });

        this.observer.observe(
          this,
          {
            childList: true,
            subtree: true,
            characterData: true
          }
        );

        this.schedule();

      }

      schedule() {

        cancelAnimationFrame(
          this.frame
        );

        this.frame =
          requestAnimationFrame(() => {
            this.updateCheckout();
          });

      }

      updateCheckout() {

        if (!this.isConnected) {
          return;
        }

        const button =
          this.querySelector(
            'button[name="checkout"]'
          );

        if (!button) {
          return;
        }

        const walker =
          document.createTreeWalker(
            button,
            NodeFilter.SHOW_TEXT
          );

        let node;
        let hasLabel = false;

        while (
          (node = walker.nextNode())
        ) {

          if (
            node.parentElement?.closest(
              'svg, script, style'
            )
          ) {
            continue;
          }

          if (
            /^(?:check\s*out|secure\s+checkout)$/i.test(
              node.textContent.trim()
            )
          ) {

            if (
              node.textContent !==
              'SECURE CHECKOUT'
            ) {
              node.textContent =
                'SECURE CHECKOUT';
            }

            hasLabel = true;

          }

        }

        if (!hasLabel) {
          return;
        }

        button.setAttribute(
          'aria-label',
          'Secure checkout'
        );

        if (
          !button.querySelector(
            '.pd-checkout-lock'
          )
        ) {

          const icon =
            document.createElementNS(
              'http://www.w3.org/2000/svg',
              'svg'
            );

          icon.setAttribute(
            'class',
            'pd-checkout-lock'
          );

          icon.setAttribute(
            'viewBox',
            '0 0 24 24'
          );

          icon.setAttribute(
            'fill',
            'none'
          );

          icon.setAttribute(
            'aria-hidden',
            'true'
          );

          icon.setAttribute(
            'focusable',
            'false'
          );

          icon.innerHTML = `
            <rect
              x="5"
              y="10"
              width="14"
              height="11"
              rx="2.5"
              stroke="currentColor"
              stroke-width="1.6"
            />

            <path
              d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          `;

          button.prepend(icon);

        }

      }

      disconnectedCallback() {

        cancelAnimationFrame(
          this.frame
        );

        this.observer?.disconnect();

      }

    }

    customElements.define(
      'pupdaily-cart-summary-v3',
      PupDailyCartSummaryV3
    );

  }
  } catch(e) { console.error(e); }
})();

})();
